import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { ChangeBankTransactionImportStatusCommandHandler } from './change-bank-import-transaction-status-handler.service';
import { BankTransactionStatusCommand } from '../../command/bankTransactionStatusCommand';
import { BankImportBookAsIncorrectPaymentCommandHandler } from './bank-import-book-as-incorrect-payment-handler.service';

@Injectable()
export class BankImportTransactionCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    changeStatus: ChangeBankTransactionImportStatusCommandHandler,
    bookAsIncorrectPayement: BankImportBookAsIncorrectPaymentCommandHandler,
    editIncorrectPayment: EditCommandHandler
  ) {
    super();
    this.addHandler(BankTransactionStatusCommand.setStatusUnhandled, changeStatus);
    this.addHandler(BankTransactionStatusCommand.setStatusHandled, bookAsIncorrectPayement);
    this.addHandler(BankTransactionStatusCommand.setStatusIngored, changeStatus);
    this.addHandler(standardCommand.edit, editIncorrectPayment);
  }
}
